import { StoreLoacationEnum } from 'app/models';

export class LocationType {
    public static LocationTypeList: Array<any> = [
        { name: 'Main Road', value: StoreLoacationEnum.Roadside },
        { name: 'Mall', value: StoreLoacationEnum.ShoppingMall },
        { name: 'Market', value: StoreLoacationEnum.Market },
        { name: 'Stall', value: StoreLoacationEnum.Stall },
        { name: 'Warehouse', value: StoreLoacationEnum.Warehouse },
        { name: 'Office Building', value: StoreLoacationEnum.OfficeBuilding },
        { name: 'Gas Station', value: StoreLoacationEnum.GasStation }
    ];
}
